import React from 'react';
import { Formik, Form, Field } from 'formik';
import { ButtonCustom, CheckboxCustom, InputCustom } from '../UI';
import AuthLinks from '../authBottomLinks';
import { validationSchema } from './validation';
import { useAppDispatch, useAppSelector } from '../../../utils/reduxHooks';
import { loginAction } from '../../../modules/auth/actions';
import { routes } from '../../../constants/routes';
import { Heading, Link, Box } from '@chakra-ui/react';
import { selectIsLoadingAuth, selectIsLoginErrorAuth } from '../../../modules/auth/selectors';
import { useAuthErrorHandling } from '../../../utils/useAuthErrorHandling';

interface FormData {
  phone: string;
  password: string;
  rememberMe: boolean;
}

const link1 = '/signUp';
const link2 = '/signUp';
const linkName1 = 'Нет аккаунта?';
const linkName2 = 'Зарегистрироваться';
const initValues = { phone: '', password: '', rememberMe: false };

export const LoginForm = () => {
  const dispatch = useAppDispatch();
  const isLoading = useAppSelector(selectIsLoadingAuth);
  const isError = useAppSelector(selectIsLoginErrorAuth);

  useAuthErrorHandling(isError);

  const onSubmit = (values: FormData) => {
    dispatch(
      loginAction.request({
        phone: values.phone,
        password: values.password,
      }),
    );
  };

  return (
    <Box
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        width: '100%',
        height: '100%',
      }}
    >
      <Formik initialValues={initValues} validationSchema={validationSchema} onSubmit={onSubmit}>
        {({ values, handleChange, errors, touched }) => (
          <Form style={{ width: '100%' }}>
            <Heading mb={6}>Войти</Heading>
            <InputCustom
              label="Телефон"
              name="phone"
              value={values.phone}
              onChange={handleChange}
              errorMessage={touched.phone && errors.phone}
              placeholder="+7 999 99-99-99"
            />
            <Box mb="20px" mt="20px">
              <InputCustom
                label="Пароль"
                type="password"
                name="password"
                value={values.password}
                onChange={handleChange}
                errorMessage={touched.password && errors.password}
                placeholder="example"
              />
            </Box>

            <Link color="#718096" href={routes.PASSWORD_RECOVERY}>
              Забыли пароль?
            </Link>
            <ButtonCustom
              mt={2}
              type="submit"
              width="100%"
              bgColor="#222"
              color="#fff"
              isLoading={isLoading}
            >
              Войти
            </ButtonCustom>
            <Field name="rememberMe" type="checkbox">
              {({ field }: { field: { value: boolean; onChange: () => void } }) => (
                <CheckboxCustom
                  name="rememberMe"
                  isChecked={field.value}
                  onChange={field.onChange}
                  style={{ marginTop: '8px' }}
                  label="Запомнить меня"
                  pt="12px"
                />
              )}
            </Field>
          </Form>
        )}
      </Formik>
      <AuthLinks link1Name={linkName1} link1Url={link1} link2Name={linkName2} link2Url={link2} />
    </Box>
  );
};
